module.exports = __webpack_public_path__ + "images/entity-market-share-analysis-0904be04.svg";